import { render, staticRenderFns } from "./BalanceDepositPoint.vue?vue&type=template&id=22e9ced3&scoped=true&"
import script from "./BalanceDepositPoint.vue?vue&type=script&lang=js&"
export * from "./BalanceDepositPoint.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDepositPoint.vue?vue&type=style&index=0&id=22e9ced3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e9ced3",
  null
  
)

export default component.exports